<template>
  <div>
    <v-toolbar flat color="white" class="py-0 my-0">
      <!-- <v-toolbar-title>Prestadores de serviços</v-toolbar-title>
      <v-spacer></v-spacer>-->

      <SvcProviderFormDlg
        :dialog="frmSvcProviderDialog"
        :openForm="() => openDialogForm()"
        :closeForm="() => closeDialogForm()"
        :saveSvcProvider="(data) => saveSvcProvider(data)"
        :editFormData="formData"
      />
    </v-toolbar>

    <SearchSvcProviders
      :searchSvcProviders="(svcProvider) => getProviders(svcProvider)"
    />

    <v-data-table :headers="headers" :items="tableData">
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon color="success" v-if="props.item.active"
            >check_circle</v-icon
          >
          <v-icon color="error" v-if="!props.item.active">block</v-icon>
        </td>
        <td class="text-xs-left">{{ props.item.name_fantasy }}</td>
        <td class="text-xs-left">{{ props.item.cnpj | formatCnpjCpf }}</td>
        <td class="text-xs-center layout">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="svcProviderPermissions.view"
                small
                class="mr-2"
                @click="editItem(props.item, 'viewForm')"
                >remove_red_eye</v-icon
              ></template
            >
            <span>Visualizar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="svcProviderPermissions.edit"
                small
                class="mr-2"
                @click="editItem(props.item)"
                >edit</v-icon
              ></template
            >
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click="confirmToogleStatusItem(props.item)"
                v-if="
                  !props.item.active &&
                  svcProviderPermissions &&
                  svcProviderPermissions.edit
                "
                >check</v-icon
              ></template
            >
            <span>Ativar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                small
                class="mr-2"
                @click="confirmToogleStatusItem(props.item)"
                v-if="
                  props.item.active &&
                  svcProviderPermissions &&
                  svcProviderPermissions.edit
                "
                >block</v-icon
              ></template
            >
            <span>Desativar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="svcProviderPermissions.remove"
                small
                @click="confirmDelSvcProvider(props.item)"
                >delete</v-icon
              ></template
            >
            <span>Excluir</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        <p>Não há dados</p>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import SvcProviderFormDlg from './SvcProvidersForm.vue'
import SearchSvcProviders from './SearchSvcProviders.vue'
import { providers } from '@/services/providers/serviceProviders'

export default {
  name: 'ServiceProviders',

  components: {
    SvcProviderFormDlg,
    SearchSvcProviders
  },

  data () {
    return {
      frmSvcProviderDialog: false,
      formData: null,
      headers: [
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'active'
        },
        { text: 'Nome do prestador', sortable: true, value: 'name_fantasy' },
        {
          text: 'CNPJ',
          value: 'cnpj',
          sortable: true,
          align: 'left'
        },
        { text: ' ', value: '', sortable: false, align: 'center' }
      ],
      tableData: []
    }
  },

  mounted () {
    this.getProviders()
  },

  computed: {
    svcProviderPermissions () {
      return this.$store.state.permissions.permissions.providers
    }
  },

  methods: {
    confirmToogleStatusItem (data) {
      let action = data.active ? 'desativar' : 'ativar'
      let obj = {
        message: `Você deseja ${action} o prestador de serviço "${data.name_fantasy}"?`,
        title: `${
          data.active
            ? 'Desativar prestador de serviço'
            : 'Ativar prestador de serviço'
        }`,
        callback: (_) => {
          this.toogleStatusItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    toogleStatusItem (data) {
      let obj = {
        url: '/api/provider/disable/' + data.id,
        query: '',
        method: 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Status modificado com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getProviders()
      })
    },

    confirmDelSvcProvider (data) {
      let obj = {
        message: `Você deseja excluir prestador de serviço "${data.name_fantasy}"?`,
        title: 'Excluir prestador de serviço',
        callback: (_) => {
          this.delSvcProvider(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delSvcProvider (data) {
      let obj = {
        url: '/api/provider/' + data.id,
        query: '',
        method: 'delete'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Prestador de serviço removido com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getProviders()
      })
    },

    openDialogForm () {
      this.formData = null
      this.frmSvcProviderDialog = true
    },

    closeDialogForm () {
      this.frmSvcProviderDialog = false
    },

    async getProviders (svcProvider = {
      name: '',
      cnpj: ''
    }) {
      this.$store.commit('showLoader', {
        circle: true
      })

      this.tableData = await providers(svcProvider)

      this.$store.commit('hideLoader')
    },

    editItem (item, view) {
      view === 'viewForm' ? (item.view = true) : (item.view = false)
      this.formData = Object.assign({}, item)
      this.frmSvcProviderDialog = true
    },

    saveSvcProvider (data) {
      let id = data.id ? `/${data.id}` : ''
      let typeMethod = data.id ? 'patch' : 'post'

      // data.type = "master";
      // data.svcProvider_id = 1;

      let obj = {
        url: '/api/provider' + id,
        query: data,
        method: typeMethod
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Perfil ${id ? 'alterado' : 'criado'} com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.frmSvcProviderDialog = false
        this.getProviders()
      })
    }
  },

  filters: {
    formatCnpjCpf (value) {
      if (value.length > 11) {
        value = value.replace(
          /^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        value = value.replace(
          /^([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})$/,
          '$1.$2.$3-$4'
        )
      }
      return value
    }
  }
}
</script>

<style>

</style>
